import type { MonospaceIndex, MonospaceIndexField } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';
import { compositeKey } from '~/rstore/utils/composite-key';

export const IndexField = withItemType<MonospaceIndexField>().defineCollection({
	name: 'MonospaceIndexField',
	scopeId: MONOSPACE_SCOPE_ID,
	getKey: (item) => compositeKey(item.indexId, item.fieldId),
	meta: {
		defaultFields: ['indexId', 'fieldId', 'order'],
	},
});

export const Index = withItemType<MonospaceIndex>().defineCollection({
	name: 'MonospaceIndex',
	scopeId: MONOSPACE_SCOPE_ID,
	meta: {
		defaultFields: ['id', 'dbName', 'kind', 'collectionId'],
	},
});
